<template>
    <div>
    
        <div class="grid-container">
            <div class="top-half"></div>
            <div class="bottom-half">
                <div class="card-container">
                    <CCard class="border-radius-16px p-4 mb-5">
                        <div class="text-center">
                            <h3 class="custom-40px-700 text-center font-color-064BB4"><img src="../assets/img/status-up-blue.png" style="max-width:48px" class="mr-2" />MyHR Solutions</h3>
                            <div class="text-left">
                                <img src="../assets/img/arrowback.png" style="max-width:20px" class="text-left" @click="GoBack()" />
                                <h4 class="custom-36px-700 font-color-171717 text-left mt-5">OTP Verification</h4>
                                <p class="custom-16px-400 text-left">We will send OTP Verification to your account from email</p>
                            </div>
    
                        </div>
    
                        <div v-if="ErrorLogin" class="ml-4 mr-4 mt-4">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error !</strong> {{ Message }}
                            </CAlert>
                        </div>
                        <div class="mt-3">
                            <h3 class="custom-14px-500 font-color-171717">Code OTP</h3>
                            <div class="verification-input">
                                <input v-model="code[0]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                <input v-model="code[1]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                <input v-model="code[2]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                                <input v-model="code[3]" maxlength="1" style="width:20%" @change="submitVerification" class="custom-code" />
                            </div>
    
                        </div>
                        <div class="text-center mt-3 mb-4">
                            <CButton class="bg-0B63F6 p-2 text-center text-white pr-5 pl-5 border-radius-half" @click="submitVerification" block>{{ lblButton }}</CButton>
                        </div>
    
                    </CCard>
                </div>
            </div>
        </div>
    
    
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            code: ["", "", "", ""],
            lblButton: "Continue"





        };
    },


    methods: {
        submitVerification() {
            this.verificationCode = this.code.join(""); // Concatenate the digits
            console.log("Verification Code:", this.verificationCode);
            this.ValidateCode(this.verificationCode);
        },
        ValidateCode(verificationCode) {
            this.lblButton = "Processing";

            const formData = new FormData();

            formData.append("userEmail", this.$route.query.email);
            formData.append("code", verificationCode);

            return this.$API
                .post(this.$ValidateForgotPasswordCode, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data > 0) {

                        this.$router.push("ResetPassword?email=" + this.$route.query.email + "&code=" + verificationCode);
                    } else {
                        this.ErrorMessage = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.data);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";

                        this.ErrorMessage = true;
                    }
                });
        },
        GoBack() {
            this.$router.push("ForgotPassword");
        }



    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>